export default "__VITE_ASSET__CasqSoWp__"